import api from './api';

const liveProductsService = {
  // Sync from Mirakl
  syncFromMirakl: (miraklConnectionId) => 
    api.post(`/live-products/sync/${miraklConnectionId}`),

  // Get all live products
  getAll: (miraklConnectionId, params = {}) => 
    api.get(`/live-products/${miraklConnectionId}`, { params }),

  // Get single product
  getOne: (id) => 
    api.get(`/live-products/product/${id}`),

  // Get stats
  getStats: (miraklConnectionId) => 
    api.get(`/live-products/stats/${miraklConnectionId}`),

  // Update price
  updatePrice: (id, price) => 
    api.put(`/live-products/price/${id}`, { price }),

  // Update stock
  updateStock: (id, quantity) => 
    api.put(`/live-products/stock/${id}`, { quantity }),

  // Bulk update stock
  bulkUpdateStock: (updates) => 
    api.put('/live-products/stock/bulk', { updates }),

  // Apply discount to single product
  applyDiscount: (id, data) => 
    api.post(`/live-products/discount/${id}`, data),

  // Remove discount from single product
  removeDiscount: (id) => 
    api.delete(`/live-products/discount/${id}`),

  // Apply bulk discount
  applyBulkDiscount: (data) => 
    api.post('/live-products/discount/bulk', data),

  // Remove bulk discount
  removeBulkDiscount: (productIds) => 
    api.delete('/live-products/discount/bulk', { data: { productIds } }),

  // Apply global discount (all products)
  applyGlobalDiscount: (miraklConnectionId, data) => 
    api.post(`/live-products/discount/global/${miraklConnectionId}`, data),

  // Remove global discount
  removeGlobalDiscount: (miraklConnectionId) => 
    api.delete(`/live-products/discount/global/${miraklConnectionId}`),
};

export default liveProductsService;